var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 32,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "57ebfbdde4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 179 362 L 572.710938 362 L 572.710938 388.878906 L 179 388.878906 Z M 179 362 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#57ebfbdde4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 558.972656 389.515625 L 192.917969 389.515625 C 185.417969 389.515625 179.359375 383.457031 179.359375 375.953125 C 179.359375 368.445312 185.417969 362.386719 192.917969 362.386719 L 558.972656 362.386719 C 566.476562 362.386719 572.53125 368.445312 572.53125 375.953125 C 572.53125 383.457031 566.476562 389.515625 558.972656 389.515625 Z M 558.972656 389.515625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessIconBlack);
export default __webpack_public_path__ + "static/media/less_icon_black.4c955aeeff2474367500ea29e466ecc8.svg";
export { ForwardRef as ReactComponent };